import React from 'react';
import PropTypes from 'prop-types';
import { Alert as ToolkitAlert } from '@quantum-ecosystem/ui-toolkit';

const spacingMap = {
	xs: '0.5rem',
	sm: '0.75rem',
	md: '1rem',
	lg: '1.5rem',
	xl: '2rem',
};

const withSpacing = (val) => {
	if (val == null) return undefined;
	if (typeof val === 'number') return `${val}px`;
	return spacingMap[val] || val;
};

const colorToVariant = {
	red: 'danger',
	danger: 'danger',
	green: 'success',
	teal: 'success',
	success: 'success',
	yellow: 'warning',
	orange: 'warning',
	warning: 'warning',
	blue: 'info',
	cyan: 'info',
	info: 'info',
};

export const FormAlert = ({
	variant,
	color,
	title,
	icon,
	withCloseButton,
	dismissible,
	onClose,
	onDismiss,
	m,
	mx,
	my,
	mt,
	mb,
	ml,
	mr,
	style,
	className,
	children,
	radius, // Mantine prop, destructured out
	...restProps
}) => {
	// Determine variant from either variant or color prop
	let resolvedVariant = 'info';
	if (variant && colorToVariant[variant]) {
		resolvedVariant = colorToVariant[variant];
	} else if (color && colorToVariant[color]) {
		resolvedVariant = colorToVariant[color];
	}

	const isDismissible = Boolean(dismissible ?? withCloseButton);
	const handleDismiss = onDismiss || onClose;

	const computedStyle = {
		margin: withSpacing(m),
		marginLeft: withSpacing(mx || ml),
		marginRight: withSpacing(mx || mr),
		marginTop: withSpacing(my || mt),
		marginBottom: withSpacing(my || mb),
		...style,
	};

	return (
		<ToolkitAlert
			variant={resolvedVariant}
			title={title}
			icon={icon}
			dismissible={isDismissible}
			onDismiss={handleDismiss}
			className={className}
			style={computedStyle}
			{...restProps}
		>
			{children}
		</ToolkitAlert>
	);
};

FormAlert.propTypes = {
	variant: PropTypes.string,
	color: PropTypes.string,
	title: PropTypes.node,
	icon: PropTypes.node,
	withCloseButton: PropTypes.bool,
	dismissible: PropTypes.bool,
	onClose: PropTypes.func,
	onDismiss: PropTypes.func,
	m: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mx: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	my: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	ml: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mr: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	style: PropTypes.object,
	className: PropTypes.string,
	children: PropTypes.node,
	radius: PropTypes.any,
};

export default FormAlert;
